import React from "react"
import styled from "styled-components"
import { Link } from "@reach/router"
import { FaFlag } from "react-icons/fa"

interface MyLinkProps {
  className?: string
  to: string
  children?: React.ReactNode
  textColor?: string
}

const MyLink = ({ className, to, children }: MyLinkProps) => (
  <Link to={to} className={className}>
    {children}
  </Link>
)

const StyledHeader = styled(MyLink)<MyLinkProps>`
  text-decoration: none;
  color: ${(props: any) => props.textColor || props.theme.colors.grey};
  font-size: 1rem;
  font-weight: bolder;
  display: flex;
  align-items: center;
  & span {
    margin-right: 0.5rem;
  }
  @media (max-width: 768px) {
    font-weight: bold;
    & svg {
      padding: 0;
    }
  }
`

export interface LogoProps {
  textColor?: string
  text?: string
}

export default function({ textColor, text }: LogoProps) {
  return (
    <StyledHeader to="/" textColor={textColor}>
      <span>{text || "Feature Flagged"}</span>
      <FaFlag />
    </StyledHeader>
  )
}
